<!--
 * @Description: 秒杀广告位轮播
 * @Author: kayvor
 * @Date: 2020-03-31 11:46:40
 * @LastEditTime: 2020-04-26 12:40:06
 * @LastEditors: kayvor
 -->

<template>
  <div class="seckillSwiper-component">
        <van-swipe class="my-swipe" :autoplay="autoplay" :indicator-color="indicatorColor">
            <van-swipe-item v-for="(item, index) of imgs" :key="index" @click="goUrl(item)">
                <img v-lazy="item.img" />
            </van-swipe-item>
        </van-swipe>
  </div>
</template>

<script >
import { mapState } from 'vuex'
import { qualityImgUrl } from '@/utils/util'
import { Swipe, SwipeItem, Lazyload } from 'vant'
export default {
    name: 'seckillSwiper',
    components: {
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
        [Lazyload.name]: Lazyload,
    },
    props: {
        /**
         * 数据
         * @param {img} 图片链接
         * @param {type} 0.无跳转 1.特价活动ID 2.商品规格ID 3.H5链接 4.秒杀活动ID
         * @param {source} 根据type,返回不同的数据
         */
        imgs: {
            type: Array,
            required: true,
            validator: value => {
                value.map(item => {
                    if (!item.img) return
                    item.img = qualityImgUrl(item.img, {
                        width: 690,
                        height: 322
                    })
                    return item
                })
                return value
            }
        },
        /**
         * 活动id
         */
        activityId: {
            type: String,
            required: true
        },
        // 自动轮播间隔，单位为 ms
        autoplay: {
            type: Number,
            default: 3000
        },
        // 指示器颜色
        indicatorColor: {
            type: String,
            default: '#dcdcdc'
        },
        contrast:{
            required: false,
            default: 'q'
        },
        percentage:{
            required: false,
            default: 100
        },
        javaStoreId: {
            type: String,
            required: true
        },
        /**
         * 门店id
         */
        sstoreId: {
            type: String,
            required: true
        },
        // 坐标
        position: {
            type: Object,
            default: () => {
                return {
                    longitude: 113.326233,
                    latitude: 23.197102
                }
            }
        }
    },
    computed: {
        ...mapState({

        })
    },
    data () {
        return {

        }
    },
    created () {

    },
    activated () {

    },
    mounted () {

    },
    methods: {
        goUrl (data) {
            const { type, source, spu_id, shelf_goods_id, topic_id } = data
            switch (type) {
            // 不跳转
            case 0: break
            // 1: 特价活动id
            case 1:
                if (!this.sstoreId) {
                    // 特价多店
                    this.$router.push({
                        path: '/marketingDetail',
                        query: {
                            topic_id
                        }
                    })
                } else {
                    // 特价单店
                    this.$router.push({
                        path: '/specialActivity',
                        query: {
                            topic_id,
                            sstore_id: this.sstoreId
                        }
                    })
                }
                break
            // 2: 商品规格id
            case 2:
                // 如果在app中跳转app商品详情页面，否则跳转h5
                if (this.$bridge.isStore()) {
                    this.$bridge.goAppGoodsDetail({
                        sstore_id: Number(this.sstoreId || 0),
                        java_storeId: Number(this.javaStoreId || 0),
                        activity_id: Number(this.activityId || 0),
                        spu_id: Number(spu_id || 0),
                        goods_id: Number(shelf_goods_id || 0),
                        goods_type: 'agent'
                    })
                } else if (this.sstoreId) {
                    this.$router.push({
                        path: '/goodsDetail',
                        query: {
                            spu_id, // 商品id
                            sstore_id: this.sstoreId, // 门店Id
                            // marketing_id: '', // marketing_id
                            goods_id: source, // 商品规格id
                            goods_type: 'agent'
                        }
                    })
                } else {
                    const { latitude, longitude } = this.position
                    // 跳转秒杀选择门店页面
                    this.$router.push({
                        path: '/seckillStoreList',
                        query: {
                            latitude,
                            longitude,
                            activity_id: this.activityId,
                            goods_id: source,
                        }
                    })
                }
                break
            // 3：跳转H5链接
            case 3:
                window.location.href = source
                break
            // 4: 秒杀活动id
            case 4:
                this.$router.push({
                    path: '/seckill',
                    query: {
                        activity_id: source,
                        sstore_id: this.sstoreId,
                        time: Date.now() // 解决正式环境跳转不了当前秒杀页面问题
                    }
                })
                break
            }
        },
    }
}
</script>

<style lang="stylus" scoped>
// @import "../../assets/stylus/variables";
.seckillSwiper-component
    box-sizing border-box
    width 100%
    padding 20px 30px 0
    height 322px
    .my-swipe
        height 100%
        border-radius 16px
</style>
<style lang="stylus">
@import "../../../../assets/stylus/variables";
.seckillSwiper-component
    .van-swipe__indicator
        width 30px
        height 4px
        // background-color #dcdcdc !important
        border-radius 2px
        transition none
        opacity 1
        &:not(:last-child)
            margin-right 9px
    .van-swipe__indicator--active
        background-color $fcPriceColor !important
    .van-swipe-item
        img
            display block
            height 100%
    .van-swipe__track
        width 100%
        height 100%
</style>
